<script setup>
import { onMounted } from 'vue';
import axios from "axios";
import ActionBar from "./components/action-bar.vue";
import Results from "./components/results.vue";
import { useMailLogStore} from "./stores/maillog";

const store = useMailLogStore();

onMounted( () => {
  // get data from db
  store.fetchLogs();
  // set in store
});
</script>

<template>
  <div>
    <ActionBar :store="store" />
    <Results />
  </div>
</template>

<style scoped>

</style>
